@if (alertsLoading$ | async) {
  <app-loading [size]="'3x'"></app-loading>
}

@if (!editMode && !createMode && !(alertsLoading$ | async)) {
  <div class="card-container alerts">
    @if (alertsCount < 1) {
      <div class="no-alerts">
        {{ "feed-alerts.message.no-alerts" | translate }}
      </div>
    }

    @for (alert of alerts$ | async; track alert.id) {
      <app-alert-card
        [alert]="alert"
        (alertEdit)="openAlertEdit($event)"
        (alertDelete)="alertDelete($event)"
      ></app-alert-card>
    }

    <app-object-card-placeholder
      [type]="'alert'"
      [action]="openAlertCreate.bind(this)"
      class="card-placeholder"
    ></app-object-card-placeholder>
  </div>
}

@if (editMode || createMode) {
  <div class="editor-container">
    <app-alert-editor
      #alertEditor
      [alert]="editMode ? selectedAlert : null"
      [feedId]="feedId"
    ></app-alert-editor>
  </div>
}
